<template>
<div>
<loading :active.sync="reverting"
        :can-cancel="false"
        :is-full-page="false" 
        :enforce-focus="true">
<md-progress-spinner style="margin-left: 50%" v-if="this.reverting" :md-diameter="80" :md-stroke="6"
                                md-mode="indeterminate" />
            <h3>{{ $t('views.order.view.tabs.label.reverting') }}</h3>
</loading>
        
    <form novalidate class="md-layout" v-if="!loading">
<md-content class=" md-layout-item md-size-100 md-small-size-100">
            <div class="md-flex-center-center md-form-input md-relative">
                <md-toolbar class="md-toolbar md-table-toolbar md-transparent md-layout md-layout-item md-size-60" md-elevation="0">
                    <div class="md-toolbar-section-start">
                        <h1 class="md-title md-subtitle">
                            {{ $t('views.order.preview.title') }} {{ form.orderType.name }}
                        </h1>
                    </div>
                    <div class="md-toolbar-section-end">
                        <md-button class="md-form-btn" style="margin-right:10px" :disabled="this.form.syncStatus == 'SYNC' || this.reverting == true || this.sending == true" @click="revertChangesAndGoBack">
                             {{ !reverting ? $t('views.orderEdit.buttons.cancelEdit') : 'Cofanie zmian...' }}
                        </md-button>
                        <md-button class="md-form-btn" :disabled="this.form.syncStatus != 'UNSYNC' || $v.$invalid || this.sending == true || this.reverting == true" @click="synchronizeOrder">
                            {{ $t('views.orderEdit.buttons.sendOrder') }}
                        </md-button>
                    </div>
</md-toolbar>
                <span class="md-error" style="font-size: 15px; margin-top:10px; color: red" 
                v-if="this.form.syncStatus == 'UNSYNC' && !$v.$invalid && this.sending == false">{{ $t('views.orderEdit.alerts.formUpdatedAlert') }}</span>
                <span class="md-error" style="font-size: 15px; margin-top:10px; color: red" 
                v-if="$v.$invalid && this.sending == false">{{ $t('views.orderEdit.alerts.formIsInvalid') }}</span>
                <md-card class="md-form-card md-mt-30">
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field>
                                <label for="agency">{{ $t('views.order.preview.label.agency') }}</label>
                                <md-input :value="common.agency.name" id="agency" name="agency" :disabled="true" />
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100">
                            <md-field>
                                <label for="client">{{ $t('views.order.preview.label.client') }}</label>
                                <md-input :value="common.client.name" id="client" name="client" :disabled="true" />
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('name', $v.common)">
                                <label for="name">{{ $t('views.order.campaign.form.label.name') }}</label>
                                <md-input name="name" id="name" v-model="$v.common.name.$model" autocomplete="off"
                                          :disabled="sending" required @change="save(false)" />
                                <span class="md-error" v-if="!$v.common.name.required">{{ $t('validation.required') }}</span>
                                <server-error :server-errors="serverErrors" field-name="name" />
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100">
<div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100 md-size-50">
                                    <md-datepicker class="md-required" v-model="$v.common.validFrom.$model"
                                                   :disabled="sending" :md-immediately="true"
                                                   :class="getValidationClass('validFrom', $v.common)"
                                                   @md-closed="saveCommonDate()">
                                        <label>{{ $t('views.order.campaign.form.label.validFrom') }}</label>
                                        <span class="md-error" v-if="!$v.common.validFrom.required">{{ $t('validation.required') }}</span>
                                        <span class="md-error" v-else-if="!$v.common.validFrom.isSameOrBefore">{{ $t('validation.isSameOrBefore', {0: $t('views.order.campaign.form.label.validTo')}) }}</span>
                                        <server-error v-else :server-errors="serverErrors"
                                                      field-name="validFrom" />
                                    </md-datepicker>
                                </div>
                                
                                <div class="md-layout-item md-small-size-100 md-size-50">
                                    <md-datepicker class="md-required" v-model="$v.common.validTo.$model"
                                                   :disabled="sending" :md-immediately="true"
                                                   :class="getValidationClass('validTo', $v.common)"
                                                   @md-closed="saveCommonDate()">
                                        <label>{{ $t('views.order.campaign.form.label.validTo') }}</label>
                                        <span class="md-error" v-if="!$v.common.validTo.required">{{ $t('validation.required') }}</span>
                                        <span class="md-error" v-else-if="!$v.common.validTo.isSameOrAfter">{{ $t('validation.isSameOrAfter', {0: $t('views.order.campaign.form.label.validFrom')}) }}</span>
                                        <server-error v-else :server-errors="serverErrors"
                                                      field-name="validTo" />
                                    </md-datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field>
                                <label for="spotType">{{ $t('views.order.preview.label.spotType') }}</label>
                                <md-input :value="form.spotType.name" id="spotType" name="spotType" :disabled="true" />
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('packageTypeId')">
                                <label for="packageType">{{ $t('views.order.tv.form.label.packageType') }}</label>
                                <SelectWithFilter :list="packageTypes" v-model="$v.form.packageTypeId.$model"
                                    :name="`packageType`" :id="`packageType`" :disabled="!form.spotTypeId || sending" v-slot="{item}">
                                    <md-option :value="item.packageType.valueId">{{ item.packageType.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.packageTypeId.required">{{ $t('validation.required') }}</span>
                                <server-error v-else field-name="packageTypeId" :server-errors="serverErrors" />
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('grpSaleTypeId')">
                                <label for="grpSaleType">{{ $t('views.order.tv.form.label.grpSaleType') }}</label>
                                <SelectWithFilter @mdselect="onGrpTypeChange()" :list="form.packageTypeId ? saleTypes : []" @input="setPriceMethod()" v-model="$v.form.grpSaleTypeId.$model"
                                    :name="`grpSaleType`" :id="`grpSaleType`" :disabled="sending" v-slot="{item}">
                                    <md-option :value="item.valueId">{{ item.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.grpSaleTypeId.required">{{ $t('validation.required') }}</span>
                                <server-error v-else field-name="grpSaleTypeId" :server-errors="serverErrors" />
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100 md-size-50" v-if="!isInternetOrRadioOrder && !isOohOrInternetOrDaOrder && !isTvOrderWithTariff && !isTvOrderWithSpot">
                            <md-field :class="getValidationClass('targetGroupId')">
                                <label for="targetGroup">{{ $t('views.order.tv.form.label.targetGroup') }}</label>
                                <SelectWithFilter @mdselect="this.isNotTariff() && this.isNotSpot() ? save(false) : ''" :list="targetGroups" v-model="$v.form.targetGroupId.$model"
                                    :name="`targetGroup`" :id="`targetGroup`" :disabled="!this.form.packageTypeId || sending" v-slot="{item}">
                                    <md-option :value="item.valueId || null">{{ item.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.targetGroupId.required">{{ $t('validation.required') }}</span>
                                <server-error v-else field-name="targetGroupId" :server-errors="serverErrors" />
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100" v-show="this.isNotTariff()">
                            <md-field :class="getValidationClass('priceMethod')">
                                <label for="priceMethod">{{ $t('views.order.tv.form.label.priceMethod') }}</label>
                                <SelectWithFilter @mdselect="this.isNotTariff() ? save(false): ''" :list="form.packageTypeId ? getPriceMethods(allowGrp) : []" @change="clearOrderMethod()" v-model="$v.form.priceMethod.$model"
                                    :name="`priceMethod`" :id="`priceMethod`" :disabled="!form.packageTypeId || sending" v-slot="{item}">
                                    <md-option :value="!form.packageTypeId ? '' : item.name ">{{ $t(`views.order.tv.form.label.${item.name}`) }}</md-option>
                                 </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.priceMethod.required">{{ $t('validation.required') }}</span>
                            </md-field>
                        </div>


                        <div class="md-layout-item md-small-size-100" v-if="getPriceMethodUnit(form.priceMethod) === 'GRP'">
                            <md-field :class="getValidationClass('grp')">
                                <label v-if="isOohOrInternetOrDaOrder" for="grp">{{ $t('views.order.internet.form.label.grp') }}</label>
                                <label v-else for="grp">{{ $t('views.order.tv.form.label.grp') }}</label>
                                <md-input name="grp" id="grp"
                                          :value="formatLocaleNumber($v.form.grp.$model)"
                                          @input="setValue(getParsedLocaleNumberOrInputString($event), '$v.form.grp.$model')"
                                          autocomplete="off"
                                          :disabled="sending" required @change="save(false)" />
                                <span v-if="!isOohOrInternetOrDaOrder" class="md-suffix">GRP</span>
                                <span class="md-error" v-if="!$v.form.grp.required">{{ $t('validation.required') }}</span>
                                <span class="md-error" v-else-if="!$v.form.grp.greaterThan">{{ $t('validation.greaterThan', {0: $v.form.grp.$params.greaterThan.value}) }}</span>
                                <span class="md-error" v-else-if="!$v.form.grp.decimal && !isOohOrInternetOrDaOrder">
                                   {{
                                        $t('validation.decimalWithPoint', {
                                            decimalPlaces: $v.form.grp.$params.decimal.decimalPlaces
                                        })
                                    }}
                                </span>
                                <server-error v-else field-name="grp" :server-errors="serverErrors" />
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100" v-if="getPriceMethodUnit(form.priceMethod) === 'PLN' && !isTvOrderWithTariff">
                            <md-field :class="getValidationClass('budget')">
                                <label for="budget">{{ $t('views.order.tv.form.label.budget') }}</label>
                                <md-input name="budget" id="budget"
                                          :value="formatLocaleNumber($v.form.budget.$model)"
                                          @input="setValue(getParsedLocaleNumberOrInputString($event), '$v.form.budget.$model')"
                                          autocomplete="off"
                                          :disabled="sending" required @change="save(false)" />
                                <span class="md-suffix">PLN</span>
                                <span class="md-error" v-if="!$v.form.budget.required">{{ $t('validation.required') }}</span>
                                <span class="md-error" v-else-if="!$v.form.budget.decimal">
                                   {{
                                        $t('validation.decimalWithPoint', {
                                            decimalPlaces: $v.form.budget.$params.decimal.decimalPlaces
                                        })
                                    }}
                                </span>
                                <span class="md-error" v-else-if="!$v.form.budget.greaterThan">{{ $t('validation.greaterThan', {0: $v.form.budget.$params.greaterThan.value}) }}</span>
                                <server-error v-else field-name="budget" :server-errors="serverErrors" />
                            </md-field>
                        </div>
                    </div>

                    <order-stations-table :add-station-handler="addStation" :allow-add-station="allowAddStation" :package-type-id="form.packageTypeId"
                                              :order-id="form.id" v-model="orderStationsList"
                                              :validator="$v.orderStationsList" :allow-edit="allowAddStation" :draft="false"
                                              :loading="orderStationsLoading" />
                                              
                    <order-products-table :add-product-handler="addProduct" :order-id="form.id"
                                          :validator="$v.orderProducts" v-model="orderProducts" :allow-edit="true" :draft="false" />

                    <order-product-sequence v-if="!isDaOrder" v-model="orderProductsSequences" class="md-mt-30" :order-products="orderProducts"
                                            :order-id="form.id" :allow-edit="true" :draft="false" />
                    <order-attachments-table :add-attachment-handler="addAttachment" :campaign-id="common.id" :order-id="form.id" v-model="orderAttachments"
                     :draft="false" />
</md-card>
            </div>
        </md-content>
</form>
    </div>
</template>

<script>
import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {OrderType} from '@/mixins/dictionariesConst';
import {
    campaignsEndpoint,
    dictionariesEndpoint,
    orderProductsEndpoint,
    ordersEndpoint, orderStationsEndpoint, orderAttachmentsEndpoint, agenciesEndpoint
} from '@/services/adsign-backend/endpoints';
import OrderProductsTable from '@/views/order/OrderProductsTable';
import OrderStationsTable from '@/views/order/OrderStationsTable';
import OrderAttachmentsTable from '@/views/order/OrderAttachmentsTable'
import OrderProductSequence from '@/views/order/product/OrderProductSequence';
import ServerError from '@/components/ServerError';
import {numeric, or, required, requiredIf} from 'vuelidate/lib/validators';
import {
    customValidation,
    decimal,
    greaterThan,
    isSameOrAfter,
    isSameOrBefore
} from '@/validators/validators';
import orderCommonsMethods from '@/mixins/orderCommonsMethods';
import SelectWithFilter from '@/components/SelectWithFilter'

export default {
    name: 'OrderEdit',
    components: {
        OrderProductSequence,
        OrderStationsTable,
        OrderProductsTable,
        ServerError,
        SelectWithFilter,
        OrderAttachmentsTable,
        Loading
    },
    mixins: [serverSideValidationErrors, orderCommonsMethods],
    props: {
        orderId: {
            type: [Number, String],
            required: true
        }
    },
    computed: {
      isOohOrInternetOrDaOrder() {
        return this.form.orderType.shortName.toLowerCase() == 'ooh' || this.form.orderType.shortName.toLowerCase() == 'internet' || this.form.orderType.shortName.toLowerCase() == 'da';
      },
      isInternetOrder() {
        return this.form.orderType.shortName.toLowerCase() == 'internet';
      },
      isDaOrder() {
        return this.form.orderType.shortName.toLowerCase() == 'da';
      },
      isInternetOrRadioOrder() {
        return this.form.orderType.shortName.toLowerCase() == 'radio' || this.form.orderType.shortName.toLowerCase() == 'internet';
      },
      isTvOrderWithTariff(){
          return this.form.orderType.shortName.toLowerCase() == 'tv' && this.form.grpSaleTypeId == '1';
      },
      isTvOrderWithSpot(){
          return this.form.orderType.shortName.toLowerCase() == 'tv' && this.form.grpSaleTypeId =='4';
      },
      priceMethods() {
            if (this.form.grpSaleTypeId) {
                const grpSalesType = this.dictionaries.grpSaleTypes.find((item) => item.valueId === this.form.grpSaleTypeId);
                if (grpSalesType) {
                    const filter = this.priceMethodsFilter[grpSalesType.name.toLowerCase()];
                    if (filter) {
                        return this.dictionaries.priceMethods.filter(filter);
                    }
                }
            }
            return this.dictionaries.priceMethods;
      },
      saleTypes() {
          return this.dictionaries.grpSaleTypes
      }
    },
    
    beforeRouteLeave (to, from, next) {
        if (this.form.syncStatus == 'UNSYNC' 
        && this.reverting == false 
        && this.sending == false 
        && to.path != '/orders/'+to.params.orderNo+'/product/'+to.params.productNo 
        && to.path != '/orders/'+to.params.orderNo+'/product'
        && to.path != '/orders/'+to.params.orderNo+'/station/'+to.params.orderStationId
        && to.path != '/orders/'+to.params.orderNo+'/station'
        && to.path != '/orders/'+to.params.orderNo+'/attachment') {
            this.reverting = true;
            ordersEndpoint.revertOrder(this.form.id).finally(() => {   
                next()
                })        
        } else {
            next()
        }
    },
    
    data: function () {
        return {
            oldValidFrom: null,
            oldValidTo: null,
            formUpdated: false,
            allowGrp: null,
            loading: true,
            sending: false,
            condition: null,
            packageTypes: {},
            reverting: false,

            priceMethodsFilter: {
                cennik: (item) => item.name === 'budget',
                spotowe: (item) => item.name === 'budget'
            },

            common: {
            },
            form: {
                id: this.orderId,
                orderType: {
                    shortName: null,
                },
                campaign: null,
                orderTypeId: null,
                spotTypeId: null,
                priceMethod: null,
                budget: null,
                grp: null,
                grpSaleTypeId: null,
                packageTypeId: null,
                targetGroupId: null,
                joinInvoices: null,
                status: null,
                syncStatus: null,
                draft: null,
                confirmDate: null,
                confirmedBy: null,
                createdBy: null
            },
            orderStations: [],
            orderStationsLoading: false,
            orderProducts: [],
            orderAttachments: [],
            orderProductsSequences: [],
            dictionaries: {
                priceMethods: [
                    {
                        name: 'grp',
                        unit: 'GRP'
                    },
                    {
                        name: 'budget',
                        unit: 'PLN'
                    }
                ],
            }
        }
    },
    mounted() {
        this.loading = true;
        this.$material.locale.firstDayOfAWeek = 1;

        ordersEndpoint.getOrder(this.orderId).then(result => {
            this.form.status = result.data.status;
            this.form.spotTypeId = result.data.spotType.valueId;
            this.form.priceMethod = result.data.budget ? 'budget' : 'grp';
            this.form.budget = result.data.budget;
            this.form.grp = result.data.grp;
            this.form.grpSaleTypeId = result.data.grpSaleType.valueId;
            this.form.packageTypeId = result.data.packageType.valueId;
            this.form.targetGroupId = result.data.targetGroup?.valueId;
            this.form.joinInvoices = result.data.paymentTogether;
            this.form.orderType = result.data.orderType;
            this.form.campaignId = result.data.campaignId;
            this.form.spotType = result.data.spotType;
            this.form.status = result.data.status;
            this.form.syncStatus = result.data.syncStatus;
            this.form.draft = result.data.draft;
            this.form.confirmDate = result.data.confirmDate;
            this.form.confirmedBy = result.data.confirmedBy;
            this.form.createdBy = result.data.createdBy;

            const promises = [];

            promises.push(campaignsEndpoint.getCampaign(this.form.campaignId).then(result => {
                this.common = {
                    ...result.data,
                    id: this.form.campaignId,
                    name: result.data.name,
                    agencyId: result.data.agency.id,
                    clientId: result.data.client.id,
                    validFrom: this.$moment(result.data.validFrom).format('L'),
                    validTo: this.$moment(result.data.validTo).format('L'),
                    description: result.data.description
                };
                agenciesEndpoint.getAgencyAllowGrp(this.common.agencyId).then(result => {
            this.allowGrp = result.data;
        });

                this.loadConditions();
            }));

            promises.push(orderProductsEndpoint.getOrderProductSequences(this.orderId).then(result => {
                this.orderProductsSequences = result.data.map(seq => ({
                    id: seq.id,
                    data: seq.orderProductIds
                }));
            }));

            promises.push(orderStationsEndpoint.getOrderStations(this.form.id).then(result => {
                this.orderStations = result.data;
            }));

            promises.push(
                dictionariesEndpoint.getDictionary('grp_sale_type')
                    .then(result => {
                        let filteredGrpSalesTypes = [];
                        this.dictionaries.grpSaleTypes = result.data
                        if (this.form.orderType.shortName == OrderType.Radio) {
                            for (let i = 0; i < this.dictionaries.grpSaleTypes.length; i++) {
                                if (this.dictionaries.grpSaleTypes[i].valueId == 1) {
                                    filteredGrpSalesTypes.push(this.dictionaries.grpSaleTypes[i]);
                                    this.dictionaries.grpSaleTypes = filteredGrpSalesTypes;
                                }
                            }
                        } 
                        else if (this.form.orderType.shortName == OrderType.OOH) {
                            for (let i = 0; i < this.dictionaries.grpSaleTypes.length; i++) {
                                if (this.dictionaries.grpSaleTypes[i].valueId == 4) {
                                    filteredGrpSalesTypes.push(this.dictionaries.grpSaleTypes[i]);
                                    this.dictionaries.grpSaleTypes = filteredGrpSalesTypes;
                                }
                            }
                        }     
                        else if (this.form.orderType.shortName == OrderType.Internet || this.form.orderType.shortName == OrderType.DA) {
                            for (let i = 0; i < this.dictionaries.grpSaleTypes.length; i++) {
                                if (this.dictionaries.grpSaleTypes[i].valueId == 3) {
                                    filteredGrpSalesTypes.push(this.dictionaries.grpSaleTypes[i]);
                                    this.dictionaries.grpSaleTypes = filteredGrpSalesTypes;
                                }
                            }
                        }                     
                    })
            );

            promises.push(orderAttachmentsEndpoint.getOrderAttachments(this.form.id)
                .then(result => this.orderAttachments = result));

            promises.push(orderProductsEndpoint.getOrderProducts(this.orderId).then(result => {
                this.orderProducts = result.data.map((orderProduct, index) => ({
                    id: orderProduct.id,
                    no: index + 1,
                    productId: orderProduct.product.id,
                    productName: orderProduct.product.name,
                    duration: orderProduct.duration,
                    productShare: orderProduct.productShare,
                    productCategory: orderProduct.productCategory,
                    positionShare: orderProduct.positionShare,
                    primeTimeShare: orderProduct.primeTimeShare,
                    validFrom: orderProduct.validFrom && this.$moment(orderProduct.validFrom).format('L') || null,
                    validTo: orderProduct.validTo && this.$moment(orderProduct.validTo).format('L') || null
                }));
            }))

            Promise.all(promises).finally(() => {
                this.loading = false;
                this.$nextTick(() => {
                    this.$v.$reset();
                });

                this.$watch(() => ({
                    packageTypeId: this.form.packageTypeId,
                    targetGroupId: this.form.targetGroupId,
                }), (newValue, oldValue) => {
                    this.$nextTick(() => {
                        this.save(newValue.packageTypeId != oldValue.packageTypeId);
                    })
                });
            })
        }); 
    },
    methods: {
        saveCommonDate() {
        this.oldValidFrom = this.common.validFrom
        this.oldValidTo = this.common.validTo
        this.$nextTick(() => {
            if (this.oldValidFrom != this.common.validFrom) {
                this.save(false)
                }
            if (this.oldValidTo != this.common.validTo) {
                this.save(false)
                } 
            })
        },
        onGrpTypeChange() {
            this.setDefaultValues();
            const priceMethods = this.getPriceMethods(null);
            if (!priceMethods.some((item) => item.name === this.form.priceMethod)) {
                this.form.priceMethod = priceMethods[0].name;
            }
            this.save(false);
        },
        setDefaultValues() {
            if (this.form.orderType.shortName == 'TV') {
                if ((this.form.grpSaleTypeId == '1')){
                    this.form.budget = ''
                    this.priceMethod = 'budget'
                    this.form.budget = 0.1;
                }
                else if ((this.form.grpSaleTypeId == '4')) {
                   this.form.budget = ''
                } else {
                    this.form.budget = 0
                }
            }
        },
        clearOrderMethod() {   
            if (this.form.priceMethod === 'budget') {
                this.form.grp = 0;   
            }
            if (this.form.priceMethod === 'grp') {
                this.form.budget = 0;
            }
        },
        isNotTariff() {
            return this.form.grpSaleTypeId !='1';
        },
        isNotSpot() {
            return this.form.grpSaleTypeId !='4';
        },
        selectDefaultTargetGroup() {
            if(this.targetGroups.length > 0) {
                this.$v.form.targetGroupId.$model = this.targetGroups[0].valueId;
            }
        },

        revertChangesAndGoBack() {
            this.reverting = true;
            ordersEndpoint.revertOrder(this.form.id).finally(() => {
                this.$router.push(`/dashboard`);
            })
        },
        synchronizeOrder() {
            this.sending = true;
            ordersEndpoint.synchronizeOrder(this.orderId, false).finally(() => {
                this.$router.push(`/orders/view/${this.form.id}/preview`);
            });
             
        },

        addProduct() {
            this.$v.form.$touch();
            const productsShare = this.orderProducts.reduce((share, orderProduct) => share + orderProduct.productShare, 0);
            if (!this.$v.form.$invalid && this.form.id && productsShare < 1) {
                this.$router.push(`/orders/${this.form.id}/product`);
            }
        },

        addStation() {
            this.$v.form.$touch();
            const stationShare = this.orderStationsList.reduce((share, orderStation) => share + orderStation.stationShare, 0);
            if (!this.$v.form.$invalid && this.form.id && stationShare < 1) {
                this.$router.push(`/orders/${this.form.id}/station`);
            }
        },

        addAttachment(){
            this.$v.form.$touch();
            if (!this.$v.form.$invalid && this.form.id) {
                return this.$router.push(`/orders/${this.form.id}/attachment`)
            }
        },

        save(updateOrderStationsList = false) {
            if (!this.$v.form.$invalid && !this.$v.form.$dirty) {
                this.updateOrder().then(() => {
                    if (updateOrderStationsList) {
                        this.orderStationsLoading = true;
                        orderStationsEndpoint.getOrderStations(this.form.id).then(result => {
                            this.orderStations = result.data;
                        }).finally(() => this.orderStationsLoading = false);
                    }
                });
            }
            if (!this.$v.common.$invalid && this.$v.common.$anyDirty) {
                this.updateCampaign();
            }
            this.form.syncStatus = 'UNSYNC';
        },

        updateOrder() {
            const orderData = {
                campaignId: this.common.id,
                orderType: { valueId: this.form.orderType.valueId },
                spotType: { valueId: this.form.spotTypeId },
                grpSaleType: { valueId: this.form.grpSaleTypeId },
                packageType: { valueId: this.form.packageTypeId },
                targetGroup: { valueId: this.form.targetGroupId },
                ...(this.includeJoinInvoices && {paymentTogether: true}),
                ...(this.form.priceMethod == 'budget' && {budget: this.removeThousandSeparator(this.form.budget)}),
                ...(this.form.priceMethod == 'grp' && {grp: this.removeThousandSeparator(this.form.grp)}),
            }

            if (this.form.id) {
                this.$v.form.$reset();
                this.formUpdated = false;
                return ordersEndpoint.updateOrder(this.form.id, orderData, false).then(result => {
                    this.form.status = result.data.status;
                    this.form.spotTypeId = result.data.spotType.valueId;
                    this.form.priceMethod = result.data.budget != null ? 'budget' : 'grp';
                    this.form.budget = result.data.budget > 0.2 ? result.data.budget : 0.1;
                    this.form.grp = result.data.grp;
                    this.form.packageTypeId = result.data.packageType.valueId;
                    this.form.grpSaleTypeId = result.data.grpSaleType.valueId;
                    this.form.targetGroupId = result.data.targetGroup.valueId;
                    this.form.joinInvoices = result.data.paymentTogether;
                    this.form.orderType = result.data.orderType;
                    this.form.campaignId = result.data.campaignId;
                    this.form.spotType = result.data.spotType;
                    this.form.status = result.data.status;
                    this.form.syncStatus = result.data.syncStatus;
                    this.form.draft = result.data.draft;
                });
            }
        },

        updateCampaign() {
            const campaignData = {
                name: this.common.name,
                validFrom: this.$moment(this.common.validFrom, 'L').format('YYYY-MM-DDT00:00:00'),
                validTo: this.$moment(this.common.validTo, 'L').format('YYYY-MM-DDT00:00:00'),
                clientId: this.common.clientId,
                agencyId: this.common.agencyId,
                description: this.common.description
            }

            if (this.common.id) {
                this.$v.common.$reset();
                this.formUpdated = false;
                return campaignsEndpoint.updateCampaign(this.common.id, campaignData, false);
            }
        },
        setPriceMethod(){
            this.form.priceMethod = this.getDefaultPriceMethodName();
        },
        getDefaultPriceMethodName() {
            return 'budget';
        }
    },
    created() {
        EventBus.$on('order-product-sequence', () => {
        this.$forceUpdate();
    });
    },
    validations() {
        const isPriceMethodSelected = (priceMethod) => this.form.priceMethod == priceMethod;
        const isOohOrInternetOrDaOrder = () => {
            return this.form.orderType.shortName == OrderType.OOH || this.form.orderType.shortName == OrderType.Internet || this.form.orderType.shortName == OrderType.DA;
        }
        const isOohOrInternetOrRadioOrDaOrder = () => {
            return this.form.orderType.shortName == OrderType.OOH || this.form.orderType.shortName == OrderType.Internet || this.form.orderType.shortName == OrderType.Radio || this.form.orderType.shortName == OrderType.DA
        }
        return {
            form: {
                spotTypeId: {
                    required
                },
                priceMethod: {
                    required
                },
                budget: {
                    required: requiredIf(() => isPriceMethodSelected('budget')),
                    ...isPriceMethodSelected('budget') && {
                        decimal: decimal(2),
                        greaterThan: greaterThan(0)
                    }
                },
                grp: {
                    required: requiredIf(() => isPriceMethodSelected('grp')),
                    ...isPriceMethodSelected('grp') && {
                        ...isOohOrInternetOrDaOrder() && {
                            numeric  //GRP for internet and ooh must be integer
                        } || {
                            decimal: decimal(2)
                        },
                        greaterThan: greaterThan(0)
                    }
                },
                grpSaleTypeId: {
                    required
                },
                packageTypeId: {
                    required
                },
                targetGroupId: {
                    ...!isOohOrInternetOrRadioOrDaOrder() && {
                        required
                    }
                },
                joinInvoices: {},
            },
            common: {
                name: {
                    required
                },
                validFrom: {
                    required,
                    isSameOrBefore: isSameOrBefore('validTo')
                },
                validTo: {
                    required,
                    isSameOrAfter: isSameOrAfter('validFrom')
                },
            },
            orderProducts: {
                date: customValidation((value) => {
                    return !value.length || value.every(orderProduct =>
                        (!orderProduct.validFrom || this.$moment(orderProduct.validFrom, 'L').isSameOrAfter(this.$moment(this.common.validFrom, 'L'))) &&
                        (!orderProduct.validTo || this.$moment(orderProduct.validTo, 'L').isSameOrBefore(this.$moment(this.common.validTo, 'L')))
                    )
                }),
                minLength: customValidation((value) => value && value.length > 0),
                share: customValidation((value) =>
                    value.reduce((share, orderProduct) => ((share*100 + orderProduct.productShare*100)/100), 0) == 1
                )
            },
            orderStationsList: {
                ...(this.selectedPackageType?.minStationCount && !this.selectedPackageType?.stationCount && {
                    minLength: or(
                        customValidation((value, param) => value && value.length >= param, this.selectedPackageType.minStationCount),
                        customValidation(() => !this.allowAddStation)
                    )
                }),
                ...(this.selectedPackageType?.stationCount && {
                    length: or(
                        customValidation((value, param) => value && value.length == param, this.selectedPackageType.stationCount),
                        customValidation(() => !this.allowAddStation)
                    )
                }),
                share: or(
                    customValidation((value) =>
                        value.reduce((share, orderStation) => ((share*100 + orderStation.stationShare*100)/100), 0) === 1),
                    customValidation(() => !this.allowAddStation)
                )
            },
            orderProductsSequences: {
                minElements: customValidation((value) => !value.length || value.every(sequence => sequence.data.length > 1))
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
